var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 20L12.2929 19.2929L11.5858 20L12.2929 20.7071L13 20ZM28 21C28.5523 21 29 20.5523 29 20C29 19.4477 28.5523 19 28 19V21ZM18.2929 13.2929L12.2929 19.2929L13.7071 20.7071L19.7071 14.7071L18.2929 13.2929ZM12.2929 20.7071L18.2929 26.7071L19.7071 25.2929L13.7071 19.2929L12.2929 20.7071ZM13 21H28V19H13V21Z",
    fill: "#565D70"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18.5,
    transform: "matrix(-1 0 0 1 40 0)",
    stroke: "#565D70",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleArrowLeft);
export default __webpack_public_path__ + "static/media/circle-arrow-left.ed4ef02d9fe33cd1cb3f8a28812ea0b7.svg";
export { ForwardRef as ReactComponent };